import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import sharesTransferExcelModalSteps from '../constants/sharesTransferExcelModalSteps';
import { useSharesTransferExcelModal } from '../context/SharesTransferExcelModalContext';

const SharesTransferExcelModalHeader: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useSharesTransferExcelModal();

  const isPreviewStep = data.step === sharesTransferExcelModalSteps.PREVIEW;

  const renderStepPill = (
    stepNumber: number,
    label: string,
    isActive: boolean
  ) => (
    <span
      className={`badge ${isActive ? 'badge-primary' : 'badge-dim badge-outline-light'}`}
      data-testid={`shares-transfer-step-pill-${stepNumber}`}
    >
      {stepNumber}. {label}
    </span>
  );

  return (
    <Modal.Header className="shares-transfer-excel-modal__header">
      <div className="d-flex flex-column flex-grow-1">
        <h5 className="modal-title mb-1">{t('UploadOperations')}</h5>
        <p className="text-soft small mb-0">
          {isPreviewStep
            ? t('SharesTransferExcelPreviewSubtitle')
            : t('SharesTransferExcelUploadSubtitle')}
        </p>
      </div>

      <div className="d-flex align-items-center">
        <div className="shares-transfer-excel-modal__step-pills d-none d-md-flex">
          {renderStepPill(
            1,
            t('SharesTransferExcelStepUpload'),
            !isPreviewStep
          )}
          {renderStepPill(
            2,
            t('SharesTransferExcelStepReview'),
            isPreviewStep
          )}
        </div>

        <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
          <em className="icon ni ni-cross" />
        </a>
      </div>
    </Modal.Header>
  );
};

export default SharesTransferExcelModalHeader;
